<template>
    <input id="loggedin-user-email" v-model="userMail" type="hidden"/>
    <router-view/>
    <LoginRegistrationFlow ref="loginRegistrationFlow"/>
</template>

<script>
import {ref, getCurrentInstance, onMounted, watch} from "vue";
import {createAuthenticationService} from './services/authenticationService';
import {useRouter} from 'vue-router';
import LoginRegistrationFlow from './registration/LoginRegistrationFlow.vue'
import { useI18n } from 'vue-i18n';
import { useLocalStorageStore } from "@/stores/localStorage"
import { storeToRefs } from "pinia";

export default {
    name: 'App',
    components: {
        LoginRegistrationFlow
    },

    setup() {
        const app = getCurrentInstance();
        const authenticationService = createAuthenticationService(app);
        const {t, messages, locale} = useI18n();
        const userMail = ref("");
        const loginRegistrationFlow = ref();
        const router = useRouter();
        const { isFinanceScope, isTechScope } = storeToRefs(useLocalStorageStore());

        router.beforeEach((to) => {
            if (!to.matched.some(x => x.meta.deferTagManager))
                console.log("GTM handled in index.html");
        });

        window.invalidDomains = [];
        const brandId = ref(0);
        const candidateDetailsLoaded = (candidate) => {
            brandId.value = candidate.brandId;
        }

        onMounted(async () => {
            app?.appContext.config.globalProperties.$auth.registerFlow(loginRegistrationFlow.value);
            userMail.value = await authenticationService.getUserEmail();
        });

        const setTitle = () => {
            const DEFAULT_TITLE = "meta.default.title";
            let scope = '';
            
            if (isTechScope.value) scope = "tech";
            if (isFinanceScope.value) scope = "finance";

            const dictionaryKey = "meta.candidate." + scope + ".title";
            const translatedTitle = t(dictionaryKey);
            if (translatedTitle === dictionaryKey)
                document.title = t(DEFAULT_TITLE);
            else
                document.title = translatedTitle;
        }

        watch(messages.value, () => {
            setTitle()
        })

        watch(locale, () => {
            setTitle()
        })

        return {
            userMail,
            brandId,
            candidateDetailsLoaded,
            loginRegistrationFlow,
        };
    }
}
</script>